import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectors as apiSelectors } from 'zender-api-client';

import * as appSelectors from '../../../../selectors';
import Poll from './Poll.component';

const PollContainer = props => <Poll {...props} />;

const mapStateToProps = state => ({
	locale: appSelectors.locale.localeSelector(state),
	config: apiSelectors.config.configSelector(state),
	queryParams: appSelectors.ui.queryParamsSelector(state),
});

const mapDispatchToProps = () => ({});

PollContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PollContainer);



// WEBPACK FOOTER //
// ./src/ui/interaction/children/poll/Poll.container.js